import { useState, useMemo, useRef } from "react"
import { useRequest } from "ahooks";
import { Card, Button, message } from "antd";
import { generateTableColumns } from "./config";
import { MemberServer } from "./../../../server";
import { Operation } from "./operation";
import { langCommon } from "../../../locales";
import { Privilege } from "./privilege";
import { Table, DEFAULT_PAGE_DATA } from "./../../../components/table";

const server = MemberServer.Role

export const Role = () => {
    const operationRef: any = useRef();
    const privilegeRef: any = useRef();

    const [loading, setLoading] = useState<boolean>(false);
    const [tableData, setTableData] = useState<any[]>([]);
    const [treeData, setTreeData] = useState<any>();
    const [pageData, setPageData] = useState<any>({ ...DEFAULT_PAGE_DATA });

    //获取表格数据
    const { run, refresh } = useRequest(server.pageList, {
        defaultParams: [{ ...pageData }],
        onBefore: () => setLoading(true),
        onFinally: () => setLoading(false),
        onError: () => {
            setTableData([]);
            setPageData({ ...pageData, Total: 0 });
        },
        onSuccess: (res: any) => {
            const { Total, List, Page, PageSize } = res;
            setTableData(List);
            setPageData({ Page, PageSize, Total });
        }
    });

    const { run: deleteData } = useRequest(server.delete, {
        manual: true,
        onBefore: () => setLoading(true),
        onFinally: () => setLoading(false),
        onSuccess: () => {
            refresh();
            message.success(langCommon?.deleteSuccess);
        }
    });


    useRequest(MemberServer.Privilege.tree, {
        onError: () => setTreeData([]),
        onSuccess: (res: any) => {
            setTreeData(res.Roots);
        }
    });


    const getTableColumns = useMemo(() => {
        return generateTableColumns({ deleteData, operationRef, privilegeRef });
    }, [deleteData, operationRef, privilegeRef]);

    return (
        <div>
            <Card className="mt20">
                <div className="flex flex-end mb20">
                    <Button className="ml10" type="primary" onClick={() => operationRef.current?.changeVisible(true, 'create')}>{langCommon?.create}</Button>
                </div>
                <Table
                    loading={loading}
                    dataSource={tableData}
                    columns={getTableColumns}
                    rowKey="Id"
                    scroll={{
                        x: 'max-content'
                    }}
                    page={pageData}
                    onPageChange={(Page: number, PageSize: number) => {
                        const currentPage = { ...pageData, Page, PageSize };
                        run({ ...currentPage });
                    }}
                />
            </Card >
            <Operation ref={operationRef} onSuccess={refresh} />
            <Privilege ref={privilegeRef} treeData={treeData} onSuccess={refresh} />
        </div>
    );
}